<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('addonsreport') }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getAddOnsReportsSelectedCinema ? 'shift-up':''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>

              <b-dropdown
                :text="getAddOnsReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="onAddOnsReportDropDownHandler({ event: $event, name:'isCinema',selectedItem: dropdownItem, index:dropdownIndex });searchCinema='';onSearchCinema()"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getAddOnsReportFromDate"
                  @click="onAddOnsReportDropDownHandler({ event: null, name: 'fromDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onAddOnsReportDropDownHandler({ event: $event, name: 'fromDate' })"
                  ref="programaticOpen"
                  :value="getAddOnsReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getAddOnsReportFromDate ? 'active': ''"
                >{{ $t('transaction') }} {{ $t("Date") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="onFetchAddOnsReport" class="btn-blue-lg w-100">{{ $tc('Get Report') }}</button>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <!-- <table border="1" class="swc-report swc-report-table">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t('outlet') }}</th>
              <th>{{ $t('username') }}</th>
              <th>{{ $t('itemname') }}</th>
              <th>{{ $t('quantity') }}</th>
              <th>{{ $t('total') }} {{ $t('sale') }}</th>
              <th>{{ $t('discounts') }}</th>
              <th>{{ $t('balance') }}</th>
            </tr>
          </thead>
          <tbody v-if="getAddOnsReportData && getAddOnsReportData.length == 0">
            <tr rowspan="7">
              <td colspan="7">{{ `No Records Found` }}</td>
            </tr>
          </tbody>
          <tbody
            v-else-if="getAddOnsReportData && getAddOnsReportData.length > 0"
            class="sph-report"
          >
            <tr v-for="(addonsItem, addonsItemIndex) in getAddOnsReportData" :key="addonsItemIndex">
              <td>-</td>
              <td>-</td>
              <td colspan="7" class="child-tables">
                <table v-for="(FnbItem, FnbItemIndex) in addonsItem.FnbItems" :key="FnbItemIndex">
                  <tr v-for="(PaymentItem, PaymentIndex) in 2" :key="PaymentIndex">
                    <td>Fanta</td>
                    <td>Cash</td>
                    <td>2</td>
                    <td>50</td>
                    <td>-</td>
                    <td>50</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>-->

        <table
          v-if="getAddOnsReportData && getAddOnsReportData.length == 0"
          border="1"
          class="swc-report swc-report-table"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t('outlet') }}</th>
              <th>{{ $t('username') }}</th>
              <th>{{ $t('addonItemName') }}</th>
              <th>{{ $t('quantity') }}</th>
              <th>{{ $t('total') }} {{ $t('sale') }}</th>
            </tr>
          </thead>

          <tbody class="sph-report">
            <tr>
              <td colspan="5">{{ $t('NoRecords') }}</td>
            </tr>
          </tbody>
        </table>

        <table
          v-if="getAddOnsReportData && getAddOnsReportData.length > 0"
          border="1"
          class="swc-report swc-report-table"
          v-for="(addOnsItem, addOnsItemIndex) in getAddOnsReportData"
          :key="addOnsItemIndex"
        >
          <thead v-if="addOnsItemIndex == 0" class="bg-lightgrey">
            <tr>
              <th>{{ $t('outlet') }}</th>
              <th>{{ $t('username') }}</th>
              <th>{{ $t('addonItemName') }}</th>
              <th>{{ $t('quantity') }}</th>
              <th>{{ $t('total') }} {{ $t('sale') }}</th>
            </tr>
          </thead>

          <tbody class="sph-report">
            <tr>
              <td>{{ addOnsItem.FnbItems[0].MultipleQuantity[0].booking_source }}</td>
              <td>{{ addOnsItem.FnbItems[0].MultipleQuantity[0].username }}</td>
              <td colspan="3" class="child-tables">
                <table v-for="(FnbItem, FnbItemIndex) in addOnsItem.FnbItems" :key="FnbItemIndex">
                  <tr>
                    <td>{{ FnbItem.MultipleQuantity[0].add_on_item_name }}</td>
                    <td>{{ FnbItem.MultipleQuantity.reduce((acc,{ add_on_quantity })=> acc + add_on_quantity ,0) }}</td>
                    <td>{{ currFormat(FnbItem.MultipleQuantity.reduce((acc,{ add_on_item_price, add_on_quantity })=> acc + (add_on_item_price * add_on_quantity) ,0)) }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="bg-lightgrey" colspan="3">
                <strong>Total</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ addOnsItem.FnbItems.map(a => a.MultipleQuantity.reduce((acc, x)=> acc += x.add_on_quantity ,0) ).reduce((a, b) => a + b, 0) }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ currFormat(addOnsItem.FnbItems.map(a => a.MultipleQuantity.reduce((acc,{ add_on_item_price, add_on_quantity })=> acc + add_on_item_price * add_on_quantity ,0) ).reduce((a, b) => a + b, 0)) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <table border="1" class="swc-report swc-report-table mt-5">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t('addonItemName') }}</th>
              <th>{{ $t('quantity') }}</th>
              <th>{{ $t('total') }} {{ $t('sale') }}</th>
            </tr>
          </thead>
          <tbody v-if="getAllAddOnsData && getAllAddOnsData.length > 0" class="sph-report">
            <tr v-for="(addonsItem, addonsItemIndex) in getAllAddOnsData" :key="addonsItemIndex">
              <td>{{ addonsItem.MultipleQuantity[0].add_on_item_name }}</td>
              <td>{{ addonsItem.MultipleQuantity.reduce((acc,{ add_on_quantity })=> acc + add_on_quantity ,0) }}</td>
              <td>{{ currFormat(addonsItem.MultipleQuantity.reduce((acc,{ add_on_item_price, add_on_quantity })=> acc + (add_on_item_price * add_on_quantity) ,0)) }}</td>
            </tr>
            <tr>
              <td class="bg-lightgrey" colspan="1">
                <strong>Total</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ getAllAddOnsData.map(a => a.MultipleQuantity.reduce((acc,{ add_on_quantity })=> acc + add_on_quantity ,0)).reduce((a, b) => a + b, 0) }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ currFormat(getAllAddOnsData.map(a => a.MultipleQuantity.reduce((acc,{ add_on_item_price, add_on_quantity })=> acc + (add_on_item_price * add_on_quantity) ,0)).reduce((a, b) => a + b, 0)) }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="3">{{ $t('NoRecords') }}</td>
            </tr>
          </tbody>
        </table>

        <div
          v-if="getAddOnsReportData && getAddOnsReportData.length > 0"
          class="d-flex justify-content-end mt-5 align-items-center"
        >
          <div>{{ $t('download') }} as:</div>
          <a
            v-if="getAddOnsPdfFileName"
            :href="BASE_URL+getAddOnsPdfFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getAddOnsExcelFileName"
            :href="BASE_URL+getAddOnsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true
    };
  },
  computed: {
    ...mapGetters([
      "getAddOnsReportsSelectedCinema",
      "getAddOnsReportFromDate",
      "getAddOnsReportData",
      "getAllAddOnsData",
      // EXCEL
      "getAddOnsExcelFileName",
      // PDF
      "getAddOnsPdfFileName"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    this.onResetAddOnsStoreState();
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onAddOnsReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "onAddOnsReportDropDownHandler",
      "onResetAddOnsStoreState",
      "onFetchAddOnsReport"
    ])
  }
};
</script>

<style scoped>
/* .sph-report th,
td {
  height: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/AddOnsReport.vue